import React from "react";
import { Helmet } from "react-helmet";
import { Translate } from "../i18n/LanguageProvider";
import Layout from "../components/layout";
//import ContactForm from "../components/contact/ContactForm";
import GoogleMap from "../components/home/GoogleMap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import WheelIcon from "../assets/svg/wheel.svg";
import SEO from "../components/seo";

const ContactInfoRow = ({ titleTranslationKey, contentTranslationKey }) => (
  <div className="columns">
    <div className="column is-3">
      <p className="is-size-5">
        <Translate>{titleTranslationKey}</Translate>:
      </p>
    </div>
    <div className="column is-9">
      <p className="is-size-5">
        <Translate>{contentTranslationKey}</Translate>
      </p>
    </div>
  </div>
);

const ContactPage = ({ pageContext: { locale } }) => {
  return (
    <Layout locale={locale}>
      <Helmet>
        <script src={`https://www.google.com/recaptcha/api.js`}></script>
      </Helmet>
      <SEO title="kontakt" />
      <div className="contact">
        <section className="container">
          <div className="tile is-ancestor">
            <div className="tile is-vertical is-12">
              <div className="tile">
                <div className="tile is-parent is-vertical">
                  <article className="tile is-child notification is-primary content">
                    <div className="columns">
                      <div className="column is-two-thirds has-text-left">
                        <h1 className="title is-1">
                          <Translate>contact.title</Translate>
                        </h1>
                        <ContactInfoRow
                          titleTranslationKey="contact.address.title"
                          contentTranslationKey="contact.address"
                        />
                        <ContactInfoRow
                          titleTranslationKey="contact.mobile.title"
                          contentTranslationKey="contact.mobile"
                        />
                        <ContactInfoRow
                          titleTranslationKey="contact.phone.title"
                          contentTranslationKey="contact.phone"
                        />
                        <ContactInfoRow
                          titleTranslationKey="contact.email.title"
                          contentTranslationKey="contact.email"
                        />
                        <div className="columns">
                          <div className="column is-3">
                            <p className="is-size-5">
                              <Translate>contact.socialmedia</Translate>:
                            </p>
                          </div>
                          <div className="column is-9">
                            <div className="social-media">
                              <a
                                href="https://www.facebook.com/varblapuhkekyla/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button is-light is-large"
                              >
                                <FontAwesomeIcon icon={faFacebook} size="lg" />
                              </a>
                              <a
                                href="https://www.instagram.com/varblapuhkekyla/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button is-light is-large"
                              >
                                <FontAwesomeIcon icon={faInstagram} size="lg" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*<ContactForm />*/}
                    </div>
                  </article>
                </div>
              </div>
              <div className="tile">
                <div className="tile is-parent is-vertical">
                  <article className="tile is-child notification is-primary content">
                    <h1 className="title is-2">
                      <Translate>contact.location</Translate>
                    </h1>
                    <WheelIcon className="icon icon--is-right" />
                    <p className="is-size-5">
                      <Translate>contact.distances</Translate>
                    </p>
                    <GoogleMap />
                  </article>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default ContactPage;
